<template>
  <a-spin size="large" :spinning="loading">
    <div class="wrap-leads">
      <div class="wrap-box">
        <div class="nav">
          <div class="title" :class="[lang]">{{ $t("importMethod") }}</div>
          <ul>
            <li
              @click="tabHandler(item.value)"
              v-for="(item, index) in navList"
              :key="index"
              :class="{
                selected: item.selected ? true : false,
                AR: lang === 'AR' ? true : false,
                disabledClick: statusIsEdit,
              }"
            >
              <img
                :src="item.url"
                :style="{
                  'margin-left': lang == 'AR' ? '10px' : '0',
                  'margin-right': lang !== 'AR' ? '10px' : '0',
                }"
              />
              <span>{{ item.label }}</span>
            </li>
          </ul>
        </div>
        <div class="formBox">
          <div class="step-hint-bar m16">
            <div class="step-hint-left">
              <span class="hand-icon">👋</span>
              <div class="step-hint-text">
                <div class="step-hint-title">
                  {{ $t("Step2HintTitle") }}
                </div>
                <div class="step-hint-desc" v-html="$t('Step2HintDesc')">
                </div>
              </div>
            </div>
            <a-button
              class="pro-hint-btn"
              :class="{ 'minimized-btn': !showTipsInfo }"
              shape="round"
              size="small"
              @click="$emit('toggleIntro', !showTipsInfo)"
            >
              {{
                showTipsInfo
                  ? $t("ProHintBtnShow")
                  : $t("ProHintBtnHide")
              }}
            </a-button>
          </div>
          <div :class="[lang]" class="title" v-if="currentIndex == 1">
            {{ $t("LinkedInSearchURL") }}
          </div>
          <div :class="[lang]" class="title" v-else-if="currentIndex == 2">
            {{ type == 1 ? $t("SalesNavigator") : $t("Recruiter") }}
          </div>
          <div :class="[lang]" class="title" v-else-if="currentIndex == 3">
            {{ $t("LinkedInEvents") }}
          </div>
          <div :class="[lang]" class="title" v-else-if="currentIndex == 4">
            {{ $t("LinkedInPosts") }}
          </div>
          <div :class="[lang]" class="title" v-else-if="currentIndex == 5">
            {{ $t("ImportfromCSV") }}
          </div>
          <div :class="[lang]" class="title" v-else-if="currentIndex == 6">
            {{ $t("LinkedInGroup") }}
          </div>

          <div
            class="mbox"
            :style="{
              height: maxWindowHeight + 'px',
              width: '100%',
            }"
          >
            <a-form :form="formLeads" class="form" ref="formLeads">
              <template v-if="currentIndex == 1">
                <div class="label-des" :class="[lang]">
                  <span>{{ $t("EnterLinkedInsearchURL") }}</span>
                </div>
                <a-form-item :class="[lang]">
                  <a-input
                    size="large"
                    class="input"
                    :disabled="statusIsEdit"
                    v-decorator="[
                      'search_url1',
                      {
                        initialValue: search_url1,
                        rules: [
                          {
                            required: true,
                            validator: async function (rule, value, callback) {
                              if (!value || !value.trim('')) {
                                callback($t('selectUrl'));
                                return;
                              }
                              // 添加逻辑校验是否存在调接口
                              let res = await isHaveSearchUrl(value);
                              if (!res.reslut) {
                                callback(res.msg);
                                return;
                              }
                              callback();
                            },
                          },
                        ],
                        trigger: 'blur',
                      },
                    ]"
                    :placeholder="$t('PleaseenterLinkedInBasicURLhere')"
                  />
                  <div class="input-tip" v-show="showTipsInfo">
                    <span class="input-tip-icon">💡</span>
                    <span class="input-tip-text">{{ $t("PasteUrlTip") }}</span>
                  </div>
                </a-form-item>

                <div class="popbox popboxAni beauty-scroll">
                  <p
                    class="main-tit"
                    :class="[lang]"
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    {{ $t("HowtofindbasicsearchURL") }}
                  </p>
                  <div
                    class="ptit"
                    :class="[lang]"
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <span
                      class="num"
                      :class="{ rtl: lang == 'AR' ? true : false }"
                      >1</span
                    ><span :class="[lang]">{{ $t("EnterkeyWords") }}</span>
                  </div>

                  <div
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <img
                      class="search"
                      src="@/assets/img/leads/1-1.png"
                      alt=""
                      style="display: inline"
                    />
                  </div>

                  <div
                    class="ptit"
                    :class="[lang]"
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <span
                      class="num"
                      :class="{ rtl: lang == 'AR' ? true : false }"
                      >2</span
                    ><span>{{ $t("CopyTheLink") }}</span>
                  </div>

                  <div
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <img
                      class="search"
                      src="@/assets/img/leads/1-2.png"
                      alt=""
                    />
                  </div>
                </div>
              </template>
              <template v-else-if="currentIndex == 2">
                <template v-if="type == 1">
                  <div class="label-des" :class="[lang]">
                    <span>{{ $t("EnterSales") }}</span>
                  </div>
                  <a-form-item :class="[lang]">
                    <a-input
                      size="large"
                      class="input"
                      :disabled="statusIsEdit"
                      v-decorator="[
                        'search_url2',
                        {
                          initialValue: search_url2,
                          rules: [
                            {
                              required: true,
                              validator: async function (
                                rule,
                                value,
                                callback,
                              ) {
                                if (!value || !value.trim('')) {
                                  callback($t('selectUrl'));
                                  return;
                                }
                                // 添加逻辑校验是否存在调接口
                                let res = await isHaveSearchUrl(value);
                                if (!res.reslut) {
                                  callback(res.msg);
                                  return;
                                }
                                callback();
                              },
                            },
                          ],
                          trigger: 'blur',
                        },
                      ]"
                      :placeholder="$t('PleaseEnterSalesNavigator')"
                    />
                    <div class="input-tip" v-show="showTipsInfo">
                      <span class="input-tip-icon">💡</span>
                      <span class="input-tip-text">{{ $t("PasteUrlTip") }}</span>
                    </div>
                  </a-form-item>
                  <div class="popbox popboxAni beauty-scroll">
                    <p
                      class="main-tit"
                      :class="[lang]"
                      :style="{
                        'text-align': lang == 'AR' ? 'right' : 'left',
                      }"
                    >
                      {{ $t("Howtofindasales") }}
                    </p>
                    <div
                      class="ptit"
                      :class="[lang]"
                      :style="{
                        'text-align': lang == 'AR' ? 'right' : 'left',
                      }"
                    >
                      <span
                        class="num"
                        :class="{ rtl: lang == 'AR' ? true : false }"
                        >1</span
                      ><span :class="[lang]">{{ $t("Openyourbrowser") }} </span>
                    </div>
                    <div
                      class="ptit"
                      :class="[lang]"
                      :style="{
                        'text-align': lang == 'AR' ? 'right' : 'left',
                      }"
                    >
                      <span
                        class="num"
                        :class="{ rtl: lang == 'AR' ? true : false }"
                        >2</span
                      ><span :class="[lang]">{{ $t("Logintoyoursales") }}</span>
                    </div>
                    <div
                      class="ptit"
                      :class="[lang]"
                      :style="{
                        'text-align': lang == 'AR' ? 'right' : 'left',
                      }"
                    >
                      <span
                        class="num"
                        :class="{ rtl: lang == 'AR' ? true : false }"
                        >3</span
                      ><span :class="[lang]"
                        >{{ $t("Enterkeywordsandpress") }}
                      </span>
                    </div>
                    <div
                      :style="{
                        'text-align': lang == 'AR' ? 'right' : 'left',
                      }"
                    >
                      <img
                        class="search"
                        src="@/assets/img/leads/2-1.png"
                        alt=""
                        style="display: inline"
                      />
                    </div>

                    <div
                      class="ptit"
                      :class="[lang]"
                      :style="{
                        'text-align': lang == 'AR' ? 'right' : 'left',
                      }"
                    >
                      <span
                        class="num"
                        :class="{ rtl: lang == 'AR' ? true : false }"
                        >4</span
                      ><span>{{ $t("Usefilterstofind") }}</span>
                    </div>

                    <div
                      :style="{
                        'text-align': lang == 'AR' ? 'right' : 'left',
                      }"
                    >
                      <img
                        class="search"
                        src="@/assets/img/leads/2-2.png"
                        alt=""
                      />
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="label-des" :class="[lang]">
                    <span>{{ $t("EnterRecruiterURL") }}</span>
                  </div>
                  <a-form-item :class="[lang]">
                    <a-input
                      size="large"
                      class="input"
                      :disabled="statusIsEdit"
                      v-decorator="[
                        'search_url2',
                        {
                          initialValue: search_url2,
                          rules: [
                            {
                              required: true,
                              validator: async function (
                                rule,
                                value,
                                callback,
                              ) {
                                if (!value || !value.trim('')) {
                                  callback($t('selectUrl'));
                                  return;
                                }
                                // 添加逻辑校验是否存在调接口
                                let res = await isHaveSearchUrl(value);
                                if (!res.reslut) {
                                  callback(res.msg);
                                  return;
                                }
                                callback();
                              },
                            },
                          ],
                          trigger: 'blur',
                        },
                      ]"
                      :placeholder="$t('RecruitersearchURLhere')"
                    />
                    <div class="input-tip" v-show="showTipsInfo">
                      <span class="input-tip-icon">💡</span>
                      <span class="input-tip-text">{{ $t("PasteUrlTip") }}</span>
                    </div>
                  </a-form-item>
                  <div class="recruiterValidUrl">
                    {{ $t("recruiterValidUrl") }}
                  </div>
                  <div class="popbox popboxAni beauty-scroll">
                    <p
                      class="main-tit"
                      :class="[lang]"
                      :style="{
                        'text-align': lang == 'AR' ? 'right' : 'left',
                      }"
                    >
                      {{ $t("RecruiterURL") }}
                    </p>
                    <div
                      class="ptit"
                      :class="[lang]"
                      :style="{
                        'text-align': lang == 'AR' ? 'right' : 'left',
                      }"
                    >
                      <span
                        class="num"
                        :class="{ rtl: lang == 'AR' ? true : false }"
                        >1</span
                      ><span :class="[lang]">{{ $t("RecruiterOpen") }} </span>
                    </div>
                    <div
                      class="ptit"
                      :class="[lang]"
                      :style="{
                        'text-align': lang == 'AR' ? 'right' : 'left',
                      }"
                    >
                      <span
                        class="num"
                        :class="{ rtl: lang == 'AR' ? true : false }"
                        >2</span
                      ><span :class="[lang]">{{
                        $t("RecruiterKeyWords")
                      }}</span>
                    </div>
                    <div
                      :style="{
                        'text-align': lang == 'AR' ? 'right' : 'left',
                      }"
                    >
                      <img
                        class="search"
                        src="@/assets/img/leads/7-1.png"
                        alt=""
                        style="display: inline"
                      />
                    </div>
                    <div
                      class="ptit"
                      :class="[lang]"
                      :style="{
                        'text-align': lang == 'AR' ? 'right' : 'left',
                      }"
                    >
                      <span
                        class="num"
                        :class="{ rtl: lang == 'AR' ? true : false }"
                        >3</span
                      ><span :class="[lang]">{{ $t("Usefilters") }} </span>
                    </div>
                    <div
                      :style="{
                        'text-align': lang == 'AR' ? 'right' : 'left',
                      }"
                    >
                      <img
                        src="@/assets/img/leads/7-2.png"
                        alt=""
                        style="display: inline; width: 180px"
                      />
                    </div>
                    <div
                      :style="{
                        'text-align': lang == 'AR' ? 'right' : 'left',
                      }"
                    >
                      <img
                        class="search"
                        src="@/assets/img/leads/7-3.png"
                        alt=""
                        style="display: inline"
                      />
                    </div>
                  </div>
                </template>
              </template>
              <template v-else-if="currentIndex == 3">
                <div class="label-des" :class="[lang]">
                  <span>{{ $t("EnterLinkedInEventURL") }}</span>
                </div>
                <a-form-item :class="[lang]">
                  <a-input
                    size="large"
                    class="input"
                    :disabled="statusIsEdit"
                    v-decorator="[
                      'search_url3',
                      {
                        initialValue: search_url3,
                        rules: [
                          {
                            required: true,
                            validator: async function (rule, value, callback) {
                              if (!value || !value.trim('')) {
                                callback($t('selectUrl'));
                                return;
                              }
                              // 添加逻辑校验是否存在调接口
                              let res = await isHaveSearchUrl(value);
                              if (!res.reslut) {
                                callback(res.msg);
                                return;
                              }
                              callback();
                            },
                          },
                        ],
                        trigger: 'blur',
                      },
                    ]"
                    :placeholder="$t('PleaseenteraLinkedInEventURLhere')"
                  />
                  <div class="input-tip" v-show="showTipsInfo">
                    <span class="input-tip-icon">💡</span>
                    <span class="input-tip-text">{{ $t("PasteUrlTip") }}</span>
                  </div>
                </a-form-item>
                <div class="keywords" v-if="keyList.length > 0">
                  <div class="avat"></div>
                  <div class="tit" :class="[lang]">
                    {{ $t("keyworkds") }}
                  </div>
                  <div class="keyList">
                    <span v-for="(item, index) in keyList" :key="index">{{
                      item
                    }}</span>
                  </div>
                </div>
                <div class="popbox popboxAni beauty-scroll">
                  <p
                    class="main-tit"
                    :class="[lang]"
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    {{ $t("HowtofindaLinkedIneventURL") }}
                  </p>
                  <div
                    class="ptit"
                    :class="[lang]"
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <span
                      class="num"
                      :class="{ rtl: lang == 'AR' ? true : false }"
                      >1</span
                    ><span :class="[lang]">{{ $t("OpenLinkedIn") }} </span>
                  </div>

                  <div
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <img
                      class="search"
                      src="@/assets/img/leads/3-1.png"
                      alt=""
                      style="display: inline"
                    />
                  </div>

                  <div
                    class="ptit"
                    :class="[lang]"
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <span
                      class="num"
                      :class="{ rtl: lang == 'AR' ? true : false }"
                      >2</span
                    ><span>{{ $t("ClickAttend") }}</span>
                  </div>

                  <div
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <img
                      class="search"
                      src="@/assets/img/leads/3-2.png"
                      alt=""
                    />
                  </div>

                  <div
                    class="ptit"
                    :class="[lang]"
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <span
                      class="num"
                      :class="{ rtl: lang == 'AR' ? true : false }"
                      >3</span
                    ><span>{{ $t("GotoAttendees") }}</span>
                  </div>

                  <div
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <img
                      class="search"
                      src="@/assets/img/leads/3-3.png"
                      alt=""
                    />
                  </div>

                  <div
                    class="ptit"
                    :class="[lang]"
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <span
                      class="num"
                      :class="{ rtl: lang == 'AR' ? true : false }"
                      >4</span
                    ><span>{{ $t("Copypaste") }}</span>
                  </div>

                  <div
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <img
                      class="search"
                      src="@/assets/img/leads/3-4.png"
                      alt=""
                    />
                  </div>
                </div>
              </template>
              <template v-else-if="currentIndex == 4">
                <div class="label-des" :class="[lang]">
                  <span>{{ $t("EnterLinkedInPostURL") }}</span>
                </div>
                <a-form-item :class="[lang]">
                  <a-input
                    size="large"
                    class="input"
                    :disabled="statusIsEdit"
                    v-decorator="[
                      'search_url4',
                      {
                        initialValue: search_url4,
                        rules: [
                          {
                            required: true,
                            validator: async function (rule, value, callback) {
                              if (!value || !value.trim('')) {
                                callback($t('selectUrl'));
                                return;
                              }
                              // 添加逻辑校验是否存在调接口
                              let res = await isHaveSearchUrl(value);
                              if (!res.reslut) {
                                callback(res.msg);
                                return;
                              }
                              callback();
                            },
                          },
                        ],
                        trigger: 'blur',
                      },
                    ]"
                    :placeholder="$t('PleaseenterLinkedInPostURLhere')"
                  />
                  <div class="input-tip" v-show="showTipsInfo">
                    <span class="input-tip-icon">💡</span>
                    <span class="input-tip-text">{{ $t("PasteUrlTip") }}</span>
                  </div>
                </a-form-item>
                <div class="wrap-box-switch">
                  <ul>
                    <li :class="[lang]">
                      <a-form-item class="item">
                        <div class="u-box" :class="[lang]">
                          <p
                            :style="{
                              'text-align': lang == 'AR' ? 'right' : 'left',
                            }"
                          >
                            <a-icon
                              type="like"
                              class="icon"
                              :style="{
                                'margin-left': lang == 'AR' ? '12px' : '0',
                                'margin-right': lang !== 'AR' ? '12px' : '0',
                              }"
                            />
                            <span>{{ $t("Likes") }}</span>
                          </p>
                          <a-switch
                            class="switch"
                            @change="showTipsVal"
                            :disabled="statusIsEdit"
                            v-decorator="[
                              'post_likes',
                              {
                                initialValue: detailObj.post_likes
                                  ? true
                                  : false,
                                valuePropName: 'checked',
                              },
                            ]"
                          />
                        </div>
                      </a-form-item>
                    </li>
                    <li :class="[lang]">
                      <a-form-item class="item">
                        <div class="u-box" :class="[lang]">
                          <p
                            :style="{
                              'text-align': lang == 'AR' ? 'right' : 'left',
                            }"
                          >
                            <a-icon
                              type="message"
                              class="icon"
                              :style="{
                                'margin-left': lang == 'AR' ? '12px' : '0',
                                'margin-right': lang !== 'AR' ? '12px' : '0',
                              }"
                            />
                            <span>{{ $t("Comments") }}</span>
                          </p>
                          <a-switch
                            class="switch"
                            @change="showTipsVal"
                            :disabled="statusIsEdit"
                            v-decorator="[
                              'post_comments',
                              {
                                initialValue: detailObj.post_comments
                                  ? true
                                  : false,
                                valuePropName: 'checked',
                              },
                            ]"
                          />
                        </div>
                      </a-form-item>
                    </li>
                    <li :class="[lang]" style="margin-bottom: 0">
                      <a-form-item class="item">
                        <div class="u-box" :class="[lang]">
                          <p
                            :style="{
                              'text-align': lang == 'AR' ? 'right' : 'left',
                            }"
                          >
                            <a-icon
                              type="retweet"
                              class="icon"
                              :style="{
                                'margin-left': lang == 'AR' ? '12px' : '0',
                                'margin-right': lang !== 'AR' ? '12px' : '0',
                              }"
                            />
                            <span>{{ $t("Reposts") }}</span>
                          </p>
                          <a-switch
                            class="switch"
                            @change="showTipsVal"
                            :disabled="statusIsEdit"
                            v-decorator="[
                              'post_reposts',
                              {
                                initialValue: detailObj.post_reposts
                                  ? true
                                  : false,
                                valuePropName: 'checked',
                              },
                            ]"
                          />
                        </div>
                      </a-form-item>
                    </li>
                  </ul>
                  <div
                    v-show="showTips"
                    :class="[lang]"
                    style="color: red; margin-top: 5px"
                  >
                    {{ $t("Note") }}
                  </div>
                </div>
                <div class="popbox beauty-scroll">
                  <p
                    class="main-tit"
                    :class="[lang]"
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    {{ $t("Howimportthepostleads") }}
                  </p>
                  <div
                    class="ptit"
                    :class="[lang]"
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <span
                      class="num"
                      :class="{ rtl: lang == 'AR' ? true : false }"
                      >1</span
                    ><span :class="[lang]"
                      >{{ $t("Findpostfromrecommendations") }}
                    </span>
                  </div>

                  <div
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <img
                      class="search"
                      src="@/assets/img/leads/4-1.png"
                      alt=""
                      style="width: 260px; height: auto; display: inline"
                    />
                  </div>

                  <div
                    class="ptit"
                    :class="[lang]"
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <span
                      class="num"
                      :class="{ rtl: lang == 'AR' ? true : false }"
                      >2</span
                    ><span>{{ $t("Pastethelinkhere") }}</span>
                  </div>

                  <div
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <img
                      class="search"
                      src="@/assets/img/leads/4-2.png"
                      alt=""
                    />
                  </div>
                </div>
              </template>
              <template v-else-if="currentIndex == 5">
                <div
                  class="label-des"
                  :class="[lang]"
                  v-if="!mappingInfo.fileName"
                >
                  <a
                    href="https://u-img.strategybrain.ca/images/files/Import_Template.csv"
                    target="_blank"
                  >
                    <a-icon
                      type="cloud-download"
                      style="margin-right: 5px; font-size: 16px"
                      :style="{
                        'margin-left': lang == 'AR' ? '5px' : '0',
                        'margin-right': lang !== 'AR' ? '5px' : '0',
                      }"
                    /><span>{{ $t("DownloadexampleCSV") }}</span>
                  </a>
                </div>
                <div v-if="!mappingInfo.fileName" class="wrap-upload">
                  <a-spin
                    size="large"
                    :spinning="uploading"
                    :tip="$t('uploading')"
                  >
                    <a-upload-dragger
                      name="file"
                      :multiple="false"
                      :showUploadList="false"
                      :before-upload="beforeUpload"
                      @change="handleChange"
                    >
                      <p class="ant-upload-drag-icon">
                        <a-icon type="cloud-upload" />
                      </p>
                      <p class="ant-upload-text">
                        {{ $t("DropCSVupload") }}
                      </p>
                    </a-upload-dragger>
                  </a-spin>
                </div>
                <div
                  class="wrap-upload"
                  style="margin-top: 12px"
                  v-if="mappingInfo.fileName"
                >
                  <a-spin
                    size="large"
                    :spinning="uploading"
                    :tip="$t('uploading')"
                  >
                    <a-upload
                      style="display: block; width: 100"
                      name="file"
                      :multiple="false"
                      :showUploadList="false"
                      :before-upload="beforeUpload"
                      @change="handleChange"
                    >
                      <div class="uploadInfo">
                        {{ $t("UploadSheet") }} {{ getFileName(mappingInfo.fileName) }} |
                        {{ mappingInfo.total }} {{ $t("LeadsUnit") }}
                      </div>
                    </a-upload>
                  </a-spin>
                </div>

                <template v-if="mappingInfo.fileName">
                  <div class="label-des" :class="[lang]">
                    <span>{{ $t("MapLinkedInUR") }}</span>
                  </div>

                  <a-form-item :class="[lang]" style="margin-bottom: 14px">
                    <a-select
                      class="select"
                      :placeholder="$t('LinkedInUrlPlaceholder')"
                      size="large"
                      v-decorator="[
                        'linkedin_url',
                        {
                          initialValue:
                            detailObj.field_mapping.linkedin_url ||
                            mappingInfo.linkUrl.default,
                          trigger: ['change'],
                          rules: [
                            {
                              required: true,
                              message: $t('required'),
                            },
                          ],
                        },
                      ]"
                    >
                      <a-select-option
                        :class="[lang]"
                        :value="item"
                        v-for="(item, key) in mappingInfo.linkUrl.list"
                        :key="key"
                      >
                        <div class="optionCont">
                          {{ item }}
                        </div>
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <div class="label-des" :class="[lang]">
                    <span>{{ $t("MapFirstName") }}</span>
                  </div>
                  <a-form-item :class="[lang]" style="margin-bottom: 14px">
                    <a-select
                      class="select"
                      :placeholder="$t('FirstName')"
                      size="large"
                      v-decorator="[
                        'first_name',
                        {
                          initialValue:
                            detailObj.field_mapping.first_name ||
                            mappingInfo.firstName.default,
                          trigger: 'change',
                          rules: [
                            {
                              required: true,
                              message: $t('required'),
                            },
                          ],
                        },
                      ]"
                    >
                      <a-select-option
                        :class="[lang]"
                        :value="item"
                        v-for="(item, key) in mappingInfo.firstName.list"
                        :key="key"
                      >
                        <div class="optionCont">
                          {{ item }}
                        </div>
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <div class="label-des" :class="[lang]">
                    <span>{{ $t("MapLastName") }}</span>
                  </div>
                  <a-form-item :class="[lang]" style="margin-bottom: 14px">
                    <a-select
                      class="select"
                      :placeholder="$t('LastName')"
                      size="large"
                      v-decorator="[
                        ' last_name',
                        {
                          initialValue:
                            detailObj.field_mapping.last_name ||
                            mappingInfo.lastName.default,
                          trigger: 'change',
                          rules: [
                            {
                              required: true,
                              message: $t('required'),
                            },
                          ],
                        },
                      ]"
                    >
                      <a-select-option
                        :class="[lang]"
                        :value="item"
                        v-for="(item, key) in mappingInfo.lastName.list"
                        :key="key"
                      >
                        <div class="optionCont">
                          {{ item }}
                        </div>
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <div class="label-des" :class="[lang]">
                    <span>{{ $t("MapCompany") }}</span>
                  </div>
                  <a-form-item :class="[lang]" style="margin-bottom: 14px">
                    <a-select
                      class="select"
                      :placeholder="$t('None')"
                      size="large"
                      v-decorator="[
                        'company_name',
                        {
                          initialValue:
                            detailObj.field_mapping.company_name ||
                            mappingInfo.companyName.default,
                        },
                      ]"
                    >
                      <a-select-option value="" :class="[lang]">
                        {{ $t("None") }}
                      </a-select-option>
                      <a-select-option
                        :class="[lang]"
                        :value="item"
                        v-for="(item, key) in mappingInfo.companyName.list"
                        :key="key"
                      >
                        <div class="optionCont">
                          {{ item }}
                        </div>
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <div class="label-des" :class="[lang]">
                    <span>{{ $t("MapLocation") }}</span>
                  </div>
                  <a-form-item :class="[lang]" style="margin-bottom: 14px">
                    <a-select
                      class="select"
                      :placeholder="$t('None')"
                      size="large"
                      v-decorator="[
                        'location',
                        {
                          initialValue:
                            detailObj.field_mapping.location ||
                            mappingInfo.location.default,
                        },
                      ]"
                    >
                      <a-select-option value="" :class="[lang]">
                        {{ $t("None") }}
                      </a-select-option>
                      <a-select-option
                        :class="[lang]"
                        :value="item"
                        v-for="(item, key) in mappingInfo.location.list"
                        :key="key"
                      >
                        <div class="optionCont">
                          {{ item }}
                        </div>
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <div class="label-des" :class="[lang]">
                    <span>{{ $t("Maptitle") }}</span>
                  </div>
                  <a-form-item :class="[lang]" style="margin-bottom: 14px">
                    <a-select
                      class="select"
                      :placeholder="$t('None')"
                      size="large"
                      v-decorator="[
                        'job_title',
                        {
                          initialValue:
                            detailObj.field_mapping.job_title ||
                            mappingInfo.title.default,
                        },
                      ]"
                    >
                      <a-select-option value="" :class="[lang]">
                        {{ $t("None") }}
                      </a-select-option>
                      <a-select-option
                        :class="[lang]"
                        :value="item"
                        v-for="(item, key) in mappingInfo.title.list"
                        :key="key"
                      >
                        <div class="optionCont">
                          {{ item }}
                        </div>
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <div class="label-des" :class="[lang]">
                    <span>{{ $t("MapEmail") }}</span>
                  </div>
                  <a-form-item :class="[lang]" style="margin-bottom: 14px">
                    <a-select
                      class="select"
                      :placeholder="$t('None')"
                      size="large"
                      v-decorator="[
                        'email',
                        {
                          initialValue:
                            detailObj.field_mapping.email ||
                            mappingInfo.email.default,
                        },
                      ]"
                    >
                      <a-select-option value="" :class="[lang]">
                        {{ $t("None") }}
                      </a-select-option>
                      <a-select-option
                        :class="[lang]"
                        :value="item"
                        v-for="(item, key) in mappingInfo.email.list"
                        :key="key"
                      >
                        <div class="optionCont">
                          {{ item }}
                        </div>
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <div class="label-des" :class="[lang]">
                    <span>{{ $t("MapPhone") }}</span>
                  </div>
                  <a-form-item :class="[lang]" style="margin-bottom: 14px">
                    <a-select
                      class="select"
                      :placeholder="$t('None')"
                      size="large"
                      v-decorator="[
                        'phone_number',
                        {
                          initialValue:
                            detailObj.field_mapping.phone_number ||
                            mappingInfo.phoneNumber.default,
                        },
                      ]"
                    >
                      <a-select-option value="" :class="[lang]">
                        {{ $t("None") }}
                      </a-select-option>
                      <a-select-option
                        :class="[lang]"
                        :value="item"
                        v-for="(item, key) in mappingInfo.phoneNumber.list"
                        :key="key"
                      >
                        <div class="optionCont">
                          {{ item }}
                        </div>
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </template>

                <div class="popbox beauty-scroll" style="margin-top: 12px">
                  <p
                    class="main-tit"
                    :class="[lang]"
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    {{ $t("HowtoimporttheCSVfile") }}
                  </p>
                  <div
                    class="ptit"
                    :class="[lang]"
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <span
                      class="num"
                      :class="{ rtl: lang == 'AR' ? true : false }"
                      >1</span
                    ><span :class="[lang]">{{ $t("DropCSVfilehere") }} </span>
                  </div>

                  <div
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <img
                      class="search"
                      src="@/assets/img/leads/5-1.png"
                      alt=""
                    />
                  </div>

                  <div
                    class="ptit"
                    :class="[lang]"
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <span
                      class="num"
                      :class="{ rtl: lang == 'AR' ? true : false }"
                      >2</span
                    ><span>{{ $t("Maptheimportedfile") }}</span>
                  </div>

                  <div
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <img
                      class="search"
                      src="@/assets/img/leads/5-2.png"
                      alt=""
                    />
                  </div>
                  <div
                    class="ptit"
                    :class="[lang]"
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <span
                      class="num"
                      :class="{ rtl: lang == 'AR' ? true : false }"
                      >3</span
                    ><span>{{ $t("Clicknextstep") }}</span>
                  </div>
                </div>
              </template>
              <template v-else-if="currentIndex == 6">
                <div class="label-des" :class="[lang]">
                  <span>{{ $t("EnterLinkedInGroupURL") }}</span>
                </div>
                <a-form-item :class="[lang]">
                  <a-input
                    size="large"
                    class="input"
                    :disabled="statusIsEdit"
                    v-decorator="[
                      'search_url6',
                      {
                        initialValue: search_url6,
                        rules: [
                          {
                            required: true,
                            validator: async function (rule, value, callback) {
                              if (!value || !value.trim('')) {
                                callback($t('selectUrl'));
                                return;
                              }
                              // 添加逻辑校验是否存在调接口
                              let res = await isHaveSearchUrl(value);
                              if (!res.reslut) {
                                callback(res.msg);
                                return;
                              }
                              callback();
                            },
                          },
                        ],
                        trigger: 'blur',
                      },
                    ]"
                    :placeholder="$t('PleaseenterLinkedInGroupURLhere')"
                  />
                  <div class="input-tip" v-show="showTipsInfo">
                    <span class="input-tip-icon">💡</span>
                    <span class="input-tip-text">{{ $t("PasteUrlTip") }}</span>
                  </div>
                </a-form-item>

                <div class="popbox popboxAni beauty-scroll">
                  <p
                    class="main-tit"
                    :class="[lang]"
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    {{ $t("HowtofindLinkedInGroupURL") }}
                  </p>
                  <div
                    class="ptit"
                    :class="[lang]"
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <span
                      class="num"
                      :class="{ rtl: lang == 'AR' ? true : false }"
                      >1</span
                    ><span :class="[lang]"
                      >{{ $t("OpenLinkedInandfindthegroup") }}
                    </span>
                  </div>

                  <div
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <img
                      class="search"
                      src="@/assets/img/leads/6-1.png"
                      alt=""
                    />
                  </div>
                  <div
                    class="ptit"
                    :class="[lang]"
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <span
                      class="num"
                      :class="{ rtl: lang == 'AR' ? true : false }"
                      >2</span
                    ><span>{{ $t("ClickShowAll") }}</span>
                  </div>

                  <div
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <img
                      style="width: 280px; height: auto; display: inline"
                      src="@/assets/img/leads/6-2.png"
                      alt=""
                    />
                  </div>

                  <div
                    class="ptit"
                    :class="[lang]"
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <span
                      class="num"
                      :class="{ rtl: lang == 'AR' ? true : false }"
                      >3</span
                    ><span>{{ $t("Copythelinkandpasteithere2") }}</span>
                  </div>

                  <div
                    :style="{
                      'text-align': lang == 'AR' ? 'right' : 'left',
                    }"
                  >
                    <img
                      class="search"
                      src="@/assets/img/leads/6-3.png"
                      alt=""
                    />
                  </div>
                </div>
              </template>

              <!-- <div v-else>
                <p style="margin-top: 60px; text-align: center">
                  {{ $t("Youneedtoupgrade") }}
                </p>
                <div style="text-align: center">
                  <a-button @click="skipUpgrade" type="primary">{{
                    $t("Upgradenow")
                  }}</a-button>
                </div>
              </div> -->
            </a-form>
          </div>
        </div>
      </div>
      <div class="wrap-btn" style="margin-top: 40px; text-align: center">
        <a-button
          :class="[lang]"
          size="large"
          @click="backHandler"
          style="margin-right: 20px"
          >{{ $t("back") }}</a-button
        >
        <a-button
          :class="[lang]"
          size="large"
          @click="clickHandler('saveDraft')"
          style="margin-right: 20px"
          v-if="!statusIsEdit"
          class="save-draf-btn"
          type="primary"
          ghost
          :loading="draftLoading"
        >
          {{ $t("saveDraftBtn") }}
        </a-button>

        <a-button
          size="large"
          type="primary"
          @click="clickHandler('nextStep')"
          :class="[lang]"
          >{{ $t("NextStep") }}</a-button
        >
      </div>
    </div>

    <a-modal v-model="visible" :title="$t('quickVerification')" :footer="null">
      <p>{{ visibleInfo }}</p>
      <div class="phoneInfo" v-if="visibleCode == 202">
        <div class="icon">
          <a-icon type="mobile" />
        </div>
        <div class="leftText">
          <div class="t1">{{ $t("VerificationMethod") }}</div>
          <div class="t2">{{ $t("LinkedInMobileApp") }}</div>
        </div>
      </div>
      <div v-if="visibleCode == 541">
        <a-form :form="formValid" class="form" ref="formValid">
          <a-form-item :class="[lang]">
            <a-input
              size="large"
              class="input"
              v-decorator="[
                'validCode',
                {
                  initialValue: validCode,
                  trigger: 'change',
                  rules: [
                    {
                      required: true,
                      message: $t('required'),
                      validator: async function (rule, value, callback) {
                        if (!value || !value.trim('')) {
                          callback($t('required'));
                          return;
                        }
                        callback();
                      },
                    },
                  ],
                },
              ]"
              :placeholder="$t('EnterCode')"
            />
          </a-form-item>
        </a-form>
      </div>
      <div class="footer-btn">
        <a-button size="large" @click="cancelHandler">
          {{ $t("cancel") }}
        </a-button>
        <a-button
          size="large"
          type="primary"
          :loading="loadingCode"
          @click="submitHandler"
        >
          {{ visibleCode == 541 ? $t("submit") : $t("ApprovedApp") }}
        </a-button>
      </div>
    </a-modal>
  </a-spin>
</template>
<script>
import { debounce } from "@/utils/util";
import { mapState } from "vuex";

// import {
//   S3Client,
//   CreateMultipartUploadCommand,
//   // ListMultipartUploadsCommand,
//   // GetObjectCommand,
//   UploadPartCommand,
//   CompleteMultipartUploadCommand,
//   // AbortMultipartUploadCommand,
// } from "@aws-sdk/client-s3";
export default {
  name: "App",
  i18n: require("./i18n"),
  props: [
    "draftLoading",
    "type",
    "statusIsEdit",
    "detailObj",
    "keyList",
    "linkId",
    "showTipsInfo",
  ],
  data() {
    let that = this;
    return {
      loadingCode: false,
      visible: false,
      visibleInfo: null,
      visibleCode: null,
      search_url1: null,
      search_url2: null,
      search_url3: null,
      search_url4: null,
      search_url5: null,
      search_url6: null,
      validCode: null,
      showTips: false,
      initUploading: false,
      tipsInfo: null,
      uploadInfo: {},
      //第四项
      index4Clicked: false,
      //映射信息
      mappingInfo: {},
      wayOfWorkingSelect: [],
      //payed: 0,
      formLeads: this.$form.createForm(this, { name: "formLeads" }),
      formValid: this.$form.createForm(this, { name: "formValid" }),
      maxWindowHeight: 700,
      msg: "Welcome to Your Vue.js App",
      uploading: false,
      currentIndex: 1,
      fileList: [],
      s3: null,
      loading: false,
      navList: [
        {
          selected: true,
          value: "1",
          label: that.$t("LinkedInSearchURL"),
          url: require("./img/1.png"),
        },
        {
          selected: false,
          value: "2",
          label: that.$t("SalesNavigator"),
          url: require("./img/2.png"),
        },
        {
          selected: false,
          value: "5",
          label: that.$t("ImportfromCSV"),
          url: require("./img/5.png"),
        },
        {
          selected: false,
          value: "3",
          label: that.$t("LinkedInEvents"),
          url: require("./img/6.png"),
        },
        {
          selected: false,
          value: "4",
          label: that.$t("LinkedInPosts"),
          url: require("./img/4.png"),
        },
        {
          selected: false,
          value: "6",
          label: that.$t("LinkedInGroup"),
          url: require("./img/1.png"),
        },
      ],
    };
  },
  watch: {
    lang() {
      let that = this;
      this.navList = [
        {
          selected: false,
          value: "1",
          label: that.$t("LinkedInSearchURL"),
          url: require("./img/1.png"),
        },
        {
          selected: false,
          value: "2",
          label: that.$t("SalesNavigator"),
          url: require("./img/2.png"),
        },
        {
          selected: false,
          value: "5",
          label: that.$t("ImportfromCSV"),
          url: require("./img/5.png"),
        },
        {
          selected: true,
          value: "3",
          label: that.$t("LinkedInEvents"),
          url: require("./img/6.png"),
        },
        {
          selected: false,
          value: "4",
          label: that.$t("LinkedInPosts"),
          url: require("./img/4.png"),
        },
        {
          selected: false,
          value: "6",
          label: that.$t("LinkedInGroup"),
          url: require("./img/1.png"),
        },
      ];
      if (this.type == 2) {
        this.navList[1] = {
          selected: false,
          value: "2",
          label: that.$t("Recruiter"),
          url: require("./img/1.png"),
        };
      }
      this.navClick(this.currentIndex);
    },
    async detailObj(value) {
      console.log("+++++++++++++++++++++++", value);
      this.initData(value);
      this.showTipsVal();
    },
  },
  computed: {
    payed() {
      if (this.user && this.user.paid == 1) {
        return true;
      } else {
        return false;
      }
    },
    ...mapState("setting", ["isMobile", "systemName"]),
  },
  async mounted() {
    // this.writeLog(
    //   "create_campaign",
    //   this.type == 1 ? "sales" : "recruiter",
    //   ""
    // );
    setTimeout(() => {
      this.resizeWindow();
    }, 200);
    window.addEventListener("resize", debounce(this.resizeWindow, 300), false);
    if (this.type == 2) {
      this.navList[1] = {
        selected: false,
        value: "2",
        label: this.$t("Recruiter"),
        url: require("./img/1.png"),
      };
    }
    this.initData();
  },
  methods: {
    cancelHandler() {
      this.visible = false;
    },
    submitHandler() {
      // this.visible = false;
      this.formValid.validateFields((error, values) => {
        if (!error) {
          console.log(values);
          this.loadingCode = true;
          this.$axios(
            "/linkedin/linkedin_input_recruiter_2fa_code",
            {
              linkedin_id: parseInt(this.linkId),
              fa_code: String(values.validCode).trim(),
            },
            "post",
          ).then((res) => {
            this.loadingCode = false;
            if (res.code == 200) {
              this.visible = false;
              this.nextHandler(this.saveType, this.values);
            }
          });
        }
      });
    },
    showTipsVal() {
      setTimeout(() => {
        const values = this.formLeads.getFieldsValue();
        if (
          !values.post_comments &&
          !values.post_likes &&
          !values.post_reposts
        ) {
          this.showTips = true;
        } else {
          this.showTips = false;
        }
      }, 500);
    },
    backHandler() {
      this.writeLog(
        "create_campaign",
        this.type == 1 ? "sales" : "recruiter",
        "campaign_step2_back",
      );
      this.$emit("backHandler");
    },
    tabHandler(value) {
      if (this.statusIsEdit) {
        return;
      }
      if (this.uploading) {
        return;
      }
      this.navClick(value, true);
    },
    async initData(obj) {
      console.log("obj---------00", obj, this.detailObj);
      let { search_type, search_url } = obj || this.detailObj;
      if (obj && obj.search_url) {
        console.log("search_url", search_url);
      }

      if (search_type) {
        this.currentIndex = search_type;
      }
      if (!search_type && !search_url) {
        return;
      }

      if (search_type == 1) {
        this.search_url1 = search_url;
        setTimeout(() => {
          this.clickHandler("initLeadInfo");
        }, 2000);
      } else if (search_type == 2) {
        this.search_url2 = search_url;
        setTimeout(() => {
          this.clickHandler("initLeadInfo");
        }, 2000);
      } else if (search_type == 3) {
        this.search_url3 = search_url;
        setTimeout(() => {
          this.clickHandler("initLeadInfo");
        }, 2000);
      } else if (search_type == 4) {
        this.search_url4 = search_url;
        setTimeout(() => {
          this.clickHandler("initLeadInfo");
        }, 2000);
      } else if (search_type == 6) {
        this.search_url6 = search_url;
        setTimeout(() => {
          this.clickHandler("initLeadInfo");
        }, 2000);
      }

      this.navClick(this.currentIndex, false);
      if (search_type == 5 && search_url) {
        this.loading = true;
        try {
          const mappingInfo = await this.$axios(
            "/sales/mapping_search_field",
            {
              file_url: search_url,
            },
            "post",
          );
          this.loading = false;
          if (mappingInfo.code == 200 && mappingInfo.data) {
            this.mappingInfo = mappingInfo.data || {};
            setTimeout(() => {
              this.clickHandler("initLeadInfo");
            }, 2000);
          }
        } catch (error) {
          console.log(error);
          this.loading = false;
        }
      }
    },
    getValues(values) {
      if (!values) {
        return {};
      }
      values.search_type = this.currentIndex
        ? parseInt(this.currentIndex)
        : null;

      if (this.currentIndex == 1) {
        values.search_url = values.search_url1;
        delete values.search_url1;
      }
      if (this.currentIndex == 2) {
        values.search_url = values.search_url2;
        delete values.search_url2;
      }
      if (this.currentIndex == 3) {
        values.search_url = values.search_url3;
        delete values.search_url3;
      }
      if (this.currentIndex == 4) {
        values.search_url = values.search_url4;
        delete values.search_url4;
      }
      if (this.currentIndex == 6) {
        values.search_url = values.search_url6;
        delete values.search_url6;
      }

      if (this.currentIndex == 5) {
        values.search_url =
          this.uploadInfo.file_url || this.detailObj.search_url;
        let {
          linkedin_url,
          first_name,
          last_name,
          location,
          company_name,
          job_title,
          email,
          phone_number,
        } = values;
        let obj = {
          linkedin_url,
          first_name,
          last_name,
          location,
          company_name,
          job_title,
          email,
          phone_number,
        };
        delete values.linkedin_url;
        delete values.first_name;
        delete values.last_name;
        delete values.location;
        delete values.company_name;
        delete values.job_title;
        delete values.email;
        delete values.phone_number;

        values.field_mapping = JSON.stringify(obj);
      }
      values.search_type = parseInt(this.currentIndex);

      return values;
    },
    nextHandler(saveType, values) {
      if (saveType == "saveDraft") {
        this.writeLog(
          "create_campaign",
          this.type == 1 ? "sales" : "recruiter",
          "campaign_step2_save_draft",
        );
        this.$emit(saveType, this.getValues(this.formLeads.getFieldsValue()));
        return;
      }
      if (this.currentIndex == 4) {
        this.index4Clicked = true;
        let { post_likes, post_comments, post_reposts } = values;
        if (!post_likes && !post_comments && !post_reposts) {
          this.showTips = true;
          this.$message.error(this.$t("Note"));
          return;
        }
      }
      if (this.currentIndex == 5 && !this.mappingInfo.fileName) {
        this.$message.error(this.$t("inputCSV"));
        return;
      }

      if (saveType == "initLeadInfo") {
        this.$emit("tempLeadInfo", this.getValues(values));
      } else {
        this.writeLog(
          "create_campaign",
          this.type == 1 ? "sales" : "recruiter",
          "campaign_step2_next",
        );
        this.$emit(saveType, this.getValues(values));
      }
    },

    clickHandler(saveType) {
      if (this.uploading) {
        return;
      }
      if (saveType == "initLeadInfo") {
        this.nextHandler(saveType);
        return;
      }

      this.formLeads.validateFields((error, values) => {
        if (!error) {
          if (this.currentIndex == 2 && this.type == 2) {
            this.loading = true;
            this.$axios(
              "/linkedin/match_recruiter_search_result",
              {
                linkedin_id: parseInt(this.linkId),
                search_url: values.search_url2,
              },
              "post",
            ).then((res) => {
              this.loading = false;
              if (res.code == 200) {
                this.nextHandler(saveType, values);
              } else if (res.code == 541 || res.code == 202) {
                this.visible = true;
                this.visibleCode = res.code;
                this.visibleInfo = res.msg;
                this.saveType = saveType;
                this.values = values;
              } else {
                this.$message.error(res.msg);
              }
              console.log(res);
            });
            return;
          }
          this.nextHandler(saveType, values);
        } else {
          const list = Object.keys(error);
          if (saveType != "initLeadInfo") {
            let message = error[list[0]].errors[0].message;
            this.$message.error(message);
          }
        }
      });
    },
    saveDraft() {
      this.formLeads.validateFields((error, values) => {
        if (!error) {
          this.$emit("nextStep", values);
        }
      });
    },
    async getPresignedUrl(file_name, file_type) {
      const response = await this.$axios(
        "/s3/presigned-url",
        {
          file_name,
          file_type,
        },
        "post",
      );
      return response; // 返回包含预签名URL的响应
    },

    async uploadToS3(file) {
      try {
        // 获取预签名URL
        const { code, data } = await this.getPresignedUrl(file.name, file.type);
        if (code != 200) {
          return;
        }
        this.uploadInfo = data;

        // 创建表单数据
        const formData = new FormData();

        // 添加S3需要的字段
        Object.entries(data).forEach(([key, value]) => {
          formData.append(key, value);
        });

        // 添加文件
        formData.append("file", file);

        // 执行上传
        const uploadResponse = await fetch(decodeURI(data.url), {
          method: "put",
          body: file,
          headers: {
            "Content-Type": file.type,
          },
        });
        if (uploadResponse.status == 200) {
          const mappingInfo = await this.$axios(
            "/sales/mapping_search_field",
            {
              file_url: this.uploadInfo.file_url,
            },
            "post",
          );
          this.uploading = false;
          if (mappingInfo.code == 200 && mappingInfo.data) {
            this.mappingInfo = mappingInfo.data || {};
          }
          console.log(mappingInfo);
        } else {
          this.uploading = false;
        }

        // const uploadResponse = await this.$post(
        //   decodeURIComponent(data.url),
        //   file,
        //   {
        //     headers: {
        //       "Content-Type": file.type,
        //       //"Content-Type": "multipart/form-data",
        //     },
        //   }
        // );
        return uploadResponse;
      } catch (error) {
        console.error("上传过程中出错:", error);
        throw error;
      }
    },
    skipUpgrade() {
      if (this.user && this.user.free_info && this.user.free_info.account) {
        this.$router.push({
          path: "/setting/userSetting/plan",
          query: {
            // 有账户时可以在付完费直接绑定
            upgrade_free: this.user.free_info.account ? 1 : 0,
            // 默认选中1
            campaign_type: this.user.free_info.bind_type,
          },
        });
      } else {
        this.$router.push({
          path: "/setting/userSetting/plan",
        });
      }
    },
    navClick(value, isClick) {
      if (value == 4) {
        this.showTipsVal();
      }
      console.log(value);
      let label = "";
      if (value == 3) {
        label = "event";
      } else if (value == 4) {
        label = "post";
      } else if (value == 5) {
        label = "export CSV";
      } else if (value == 6) {
        label = "group";
      } else if (value == 1) {
        label = "search URL";
      } else if (value == 2) {
        label = "sales navigator";
      }
      if (isClick) {
        this.writeLog(
          "create_campaign",
          this.type == 1 ? "sales" : "recruiter",
          `campaign_step2_${label}`,
        );
      }

      this.navList = this.navList.map((item) => {
        item.selected = false;
        if (value == item.value) {
          item.selected = true;
          this.currentIndex = item.value;
        }
        return item;
      });
    },
    beforeUpload(file) {
      this.fileList = [...this.fileList, file];
      return false;
    },
    getFileName(url) {
      if (url) {
        let list = url.split("-");
        let newArr = list.splice(2);
        return newArr.join("-");
      } else {
        return "";
      }
    },
    async handleChange(info) {
      if (info.file) {
        try {
          let fileS = info.file.name.split(".");
          let suffix = fileS[fileS.length - 1];
          let isValid = false;
          if (suffix == "csv" || suffix == "xlsx") {
            isValid = true;
          }
          if (!isValid) {
            this.$message.error(this.$t("inputCSV"));
            this.uploading = false;
            return;
          }
          this.uploading = true;
          const fileUrl = await this.uploadToS3(info.file);
          console.log("文件已上传，地址为:", fileUrl);
        } catch (error) {
          this.uploading = false;
          console.error("上传失败:", error);
        }
      }
      // return;
      // debugger;
      // const status = info.file.status;
      // if (status !== "uploading") {
      //   console.log(info.file, info.fileList);
      // }
      // if (status === "done") {
      //   this.$message.success(`${info.file.name} file uploaded successfully.`);
      // } else if (status === "error") {
      //   this.$message.error(`${info.file.name} file upload failed.`);
      // }
    },

    // 校验搜索URL是否存在
    async isHaveSearchUrl(val) {
      let resInfo = {};
      let url =
        this.type == 2
          ? "/linkedin/check_recruiter_url"
          : "/sales/check_search_url";
      await this.$axios(
        url,
        {
          search_url: val,
          search_type: parseInt(this.currentIndex),
          linkedin_id: parseInt(this.linkId),
        },
        "post",
      ).then((res) => {
        resInfo = res && res.data;
      });
      return resInfo;
    },
    resizeWindow() {
      var h =
        document.documentElement.clientHeight || document.body.clientHeight;

      var bottomHeight = document.querySelector(".bottom")
        ? document.querySelector(".bottom").clientHeight
        : 0;
      this.bottomHeight = bottomHeight;
      let dialogHeight = h - bottomHeight - 50 - 64 - 30 - 16 - 40 - 80 - 60;

      this.maxWindowHeight = dialogHeight;
      //this.setScroll();
    },
  },
};
</script>
<style lang="less" scoped>
.phoneInfo {
  display: flex;
  border: #ccc solid 1px;
  background: #fdfdfd;
  padding: 16px;
  border-radius: 10px;
  margin-bottom: 28px;
  width: 330px;

  .t1,
  .t2 {
    height: 30px;
    line-height: 30px;
    font-weight: bold;
    font-size: 16px;
  }

  .t1 {
    color: #bbb;
  }

  .icon {
    height: 60px;
    width: 60px;
    border: #ccc solid 1px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: #fff;
    margin-right: 20px;

    i {
      font-size: 30px;
    }
  }
}

.footer-btn {
  display: flex;
  text-align: center;
  gap: 10px;

  .ant-btn {
    width: 50%;
  }
}

.wrap-leads {
  padding: 16px;
  background: #fff;
  border-radius: 4px;

  .wrap-upload {
    /deep/.ant-upload {
      display: block;
      width: 100%;
      text-align: center;
    }

    /deep/.ant-upload-drag-container {
      display: block;
      width: 100%;
      text-align: center;
    }

    .uploadInfo {
      width: 100%;
      height: 60px;
      line-height: 60px;
      text-align: center;
      border-radius: 4px;
      background-color: #fff;
      color: 14px;
      cursor: pointer;
    }

    :disabled {
      cursor: no-drop;
    }
  }

  .recruiterValidUrl {
    color: red;
    margin-bottom: 12px;
  }

  .wrap-box {
    display: flex;

    .nav {
      border-radius: 4px;
      background: #f2f3f8;
      width: 260px;

      .title {
        font-size: 16px;
        font-weight: bold;
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #ccc;
        padding: 0 8px;
      }

      ul {
        margin-top: 14px;
        padding: 0 8px;
      }

      li {
        padding: 8px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        height: 60px;
        border: 1px solid #d6d6d6;

        img {
          margin-right: 10px;
        }

        font-size: 14px;
        cursor: pointer;
      }

      .disabledClick {
        cursor: no-drop;
      }

      .selected {
        box-shadow: 0px 2px 6px 1px rgba(14, 117, 106, 0.3);
        border-radius: 4px;
        border: 2px solid #0e756a;
      }
    }

    .formBox {
      border-radius: 4px;
      background: #f2f3f8;
      margin-left: 10px;
      flex: 1;
      width: 100%;
      overflow-x: hidden;
      border-radius: 4px;
      padding: 20px 16px;

      // max-height: calc(100vh - 64px);
      .mbox {
        overflow-y: auto;
      }

      .label-des {
        font-size: 14px;
        font-weight: bold;
        height: 40px;
        line-height: 40px;
      }

      .title {
        font-size: 16px;
        font-weight: bold;
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #ccc;
        padding: 0 8px;
      }

      .form {
        padding: 0 10px 10px;

        // 校验错误提示(.ant-form-explain)排在 input 与 input-tip 之间
        /deep/.ant-form-item-control {
          display: flex;
          flex-direction: column;

          .ant-form-item-children {
            display: contents;
          }

          .ant-form-explain {
            margin-top: 6px;
            order: 1;
            font-size: 12px;
          }

          .input-tip {
            order: 2;
            margin-top:0;
            margin-bottom: 12px;
          }
        }
      }

      .wrap-box-switch {
        background-color: #fff;
        border-radius: 4px;
        padding: 10px;
        margin-bottom: 20px;

        li {
          display: flex;
          margin-bottom: 12px;
          align-items: center;

          .item {
            width: 100%;
            margin-bottom: 0;
          }

          .u-box {
            display: flex;
            align-items: center;
          }

          p {
            flex: 1;
            width: 100%;
            overflow: hidden;
            align-items: center;
            margin: 0;

            .icon {
              margin-right: 12px;
            }
          }

          .switch {
            width: 44px;
          }
        }
      }

      .popbox {
        width: 100%;
        overflow-y: auto;
        overflow-x: hidden;

        .main-tit {
          font-weight: bold;
          font-size: 16px;
          color: #0e756a;
          margin-bottom: 0;
        }

        .ptit {
          margin-top: 17px;
          font-size: 14px;
          color: #000000;
          user-select: none;

          .num {
            width: 19px;
            height: 19px;
            display: inline-block;
            font-weight: 400;
            font-size: 12px;
            color: #ffffff;
            line-height: 19px;
            text-align: center;
            margin-right: 7px;
            background: #0e756a;
            border-radius: 50%;
          }

          .rtl {
            margin-right: 0px;
            margin-left: 7px;
          }

          &-3 {
            display: flex;

            .num {
              min-width: 19px;
            }

            .con-3 {
              flex: 1;

              .txt-tip {
                color: #ff4d4f;
              }
            }
          }
        }

        .txt-red {
          color: #ff4d4f;
        }

        img {
          display: block;
          margin-top: 17px;
        }

        .search {
          // width: 375px;
          // height: 47px;
          display: inline;
          width: 536px;
          height: auto;
        }

        .tips {
        }

        .btn-box {
          margin-top: 34px;
          color: #000;

          .btn-txt {
            color: #0e756a;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.keywords {
  position: relative;
  padding: 14px;
  background-color: rgba(228, 245, 254, 1);

  .avat {
    width: 0;
    height: 0;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 20px solid rgba(228, 245, 254, 1);
    position: absolute;
    top: -20px;
    left: 15px;
  }

  .tit {
    font-size: 16px;
    font-weight: bold;
    font-style: italic;
  }

  .keyList {
    padding: 10px 10px 0 10px;
    background-color: rgba(228, 245, 254, 0.6);

    span {
      display: inline-block;
      margin-right: 10px;
      margin-bottom: 10px;
      border: rgba(64, 149, 229, 1) solid 2px;
      padding: 8px;
      border-radius: 4px;
    }
  }
}

.popboxAni {
  padding: 16px;
  border: 5px solid #ff8c1a;
  border-radius: 6px;
  animation: popboxAniBreath 1.5s ease-in-out infinite;
}

@keyframes popboxAniBreath {
  0%,
  100% {
    border-color: #ffb060;
    box-shadow: 0 0 4px rgba(255, 140, 26, 0.35);
  }

  50% {
    border-color: #ff6a00;
    box-shadow: 0 0 18px 2px rgba(255, 106, 0, 0.85);
  }
}

</style>
<style>
.step-hint-bar.m16{
  margin-bottom: 16px!important;
}
</style>
